module.exports = __webpack_public_path__ + "img/final_5.d0a1d0b4.png";